import { CircularProgress } from '@mui/material'
import React, { useEffect } from 'react'
import EmptyScreen from '../../../../components/EmptyScreen'
import RestaurantList from '../../../../components/restaurant/RestaurantList'
import {
  MOBILE_APP_HEIGHT,
  MOBILE_NAV_HEIGHT,
  MOBILE_SEARCH_HEIGHT,
} from '../../../../helpers/static-constants'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import { useAppSelector } from '../../../../store'
import {
  selectEater,
  selectSavedRestaurants,
  selectSavedRestaurantsLoading,
  selectSavedRestaurantsError,
  fetchEaterSavedRestaurants,
} from '../../../../store/profileSlice'

const ProfileSavedRestaurants: React.FC = () => {
  const { dispatch, isMediumScreen } = useAppUtilities()
  const eater = useAppSelector(selectEater)
  const savedRestaurants = useAppSelector(selectSavedRestaurants)
  const loading = useAppSelector(selectSavedRestaurantsLoading)
  const error = useAppSelector(selectSavedRestaurantsError)

  // Fetch saved restaurants on mount if eater exists and list is empty
  // Also refetch when eaterId changes (e.g., after login)
  useEffect(() => {
    if (eater?.eaterId && savedRestaurants.length === 0 && !loading && !error) {
      void dispatch(
        fetchEaterSavedRestaurants({
          eaterId: eater.eaterId,
        }),
      )
    }
    // eslint-disable-next-line
  }, [eater?.eaterId]) // Re-fetch if eaterId changes or list becomes empty

  if (loading && savedRestaurants.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </div>
    )
  }

  if (error && savedRestaurants.length === 0) {
    return (
      <EmptyScreen
        mainText="Unable to load saved restaurants"
        secondaryText={error}
        imageUrl="/images/empty-screen.svg"
        containerHeight={isMediumScreen ? '40vh' : '400px'}
      />
    )
  }

  return (
    <div>
      {savedRestaurants.length > 0 ? (
        <RestaurantList
          cardList={savedRestaurants}
          detailSource="saved"
          mobileSearchHight={`${
             `(${MOBILE_SEARCH_HEIGHT + MOBILE_APP_HEIGHT + 213}px + env(safe-area-inset-bottom) + env(safe-area-inset-top))`
          }`}
          noneMobileSearchHight={`${MOBILE_NAV_HEIGHT + 265}px`}
        />
      ) : (
        <EmptyScreen
          mainText="No data available"
          secondaryText="No restaurants found"
          imageUrl="/images/empty-screen.svg"
          containerHeight={isMediumScreen ? '40vh' : '400px'}
        />
      )}
    </div>
  )
}
export default ProfileSavedRestaurants
